module.exports = "/_next/static/images/twitter-c-icon-caeffdf632d2b7b11d21b7e2a6811a71.svg";